import React, { Fragment, FC, createElement } from 'react';

interface ParseTextWithBreaklinesProps {
  text: string;
  elementType?: 'p' | 'span' | 'h2' | 'h3' | 'h4';
}

const ParseTextWithBreaklines: FC<ParseTextWithBreaklinesProps> = ({
  text,
  elementType = 'p',
}) => {
  const Element: FC = ({ children }) =>
    createElement(elementType, null, children);

  return (
    <Element>
      {text.split('\n').map((line, index) => (
        <Fragment key={String(index)}>
          {line}
          {index % 2 === 0 && <br />}
        </Fragment>
      ))}
    </Element>
  );
};

export default ParseTextWithBreaklines;
